import { Injectable } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { IApplication } from '../model/application';

@Injectable()
export class ApplicationService {

  /**
   *
   * @type {string}
   */
  private applicationsDataUrl: string = environment.apiUrl + '/v1/applications';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) {
  }

  /**
   *
   * @return {Observable<IApplication[]>}
   */
  getApplications(): Observable<IApplication[]> {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.applicationsDataUrl)
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/application.service.ts